<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="1113 298.5 23 22">
        <g data-name="view-svgrepo-com">
            <path
                d="M1120 317.5h-7l.905-3.621a.527.527 0 0 1 .485-.379h4.22c.215 0 .433.17.485.379l.905 3.621Zm9 0h7l-.905-3.621a.527.527 0 0 0-.485-.379h-4.22a.526.526 0 0 0-.485.379L1129 317.5Z"
                fill="#92929a"
                fill-rule="evenodd"
                data-name="Path 370"
            />
            <path
                d="M1122 300c0 .275-.225.5-.5.5h-4a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5h4c.275 0 .5.225.5.5v1Zm-2 18.5h-7v1.5c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5v-1.5Zm7-18.5c0 .275.225.5.5.5h4c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-4c-.275 0-.5.225-.5.5v1Zm2 20c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5v-1.5h-7v1.5Zm-5.5-16.5a.501.501 0 0 1-.5-.5v-1c0-.275-.225-.5-.5-.5h-6c-.275 0-.5.225-.5.5v1c0 .275-.225.5-.5.5a.653.653 0 0 0-.608.488l-1.783 8.024c-.06.268.116.488.391.488h6c.275 0 .5-.225.5-.5v-1c0-.275.225-.5.5-.5h3c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5Zm2.048 0c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5h3c.275 0 .5.225.5.5v1c0 .275.225.5.5.5h6c.275 0 .451-.22.392-.488l-1.783-8.024a.655.655 0 0 0-.609-.488.501.501 0 0 1-.5-.5v-1c0-.275-.225-.5-.5-.5h-6c-.275 0-.5.225-.5.5v1c0 .275-.225.5-.5.5Z"
                fill="#92929a"
                fill-rule="evenodd"
                data-name="Path 371"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "Binoculars",
};
</script>
